if (process.env.NODE_ENV === 'development') {
	// 开发环境
	
	var host = 'https://app.woershi.cn' // 正式站
} else {
	// 生产环境
	var host = 'https://app.woershi.cn' // 正式站
	
}
// #ifdef H5
host = ''
// #endif  

var imgHost = host;
export default {
	api: {
		blankUrl: host + '',
		apiUrl: host + '/api/user',
		serviceUrl: host + '/api',
		uploadUrl: host + "/api/user/update_user_avatar",
		uploadVideo: host + "/api/upload/video"
	},
	imgHost
}
